import { amountToDisplayAmount } from "@/utils/price-utils";
import type { Dayjs } from "dayjs";
import { Text } from "../../ui/text";

interface InitialPaymentExplanationProps {
  initialPaymentPeriodToPaymentAmount: number;
  initialPaymentPeriodEnd: Dayjs;
  monthlyPaymentAmount: number;
}

export const InitialPaymentExplanation = ({
  initialPaymentPeriodToPaymentAmount,
  initialPaymentPeriodEnd,
  monthlyPaymentAmount,
}: InitialPaymentExplanationProps) => (
  <Text
    size="small"
    align="center"
    value={`Månedsavdrag betales forskuddsvis. ${
      (initialPaymentPeriodToPaymentAmount) > 0
        ? ""
        : "Man belastes for resterende dager i inneværende måned, samt påfølgende måned."
    } Neste betaling skjer ${initialPaymentPeriodEnd
      .set("month", initialPaymentPeriodEnd.month())
      .set("date", 20)
      .format("DD.MM.YYYY")} og vil være på ${amountToDisplayAmount(monthlyPaymentAmount)} kr.`}
  />
);
